import { CertificationConfirmDialog } from "../../ui";

type Props = {
  open: boolean;
  deleting: boolean;
  description: string;
  onClose: () => void;
  onConfirm: () => void;
};

export function ManualSistemaIntegradoControlModificacionDeleteModal({
  open,
  deleting,
  description,
  onClose,
  onConfirm,
}: Props) {
  return (
    <CertificationConfirmDialog
      open={open}
      title="Eliminar modificación"
      description={description}
      confirming={deleting}
      confirmLabel="Eliminar"
      eyebrow="Control documental"
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
